import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
  output,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslatePipe, _ } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { provideComponentDefaultTranslations } from '../../util/defaults-translation-handler';
import translations from './i18n';

export type Credentials = {
  username: string;
  password: string;
  remember?: boolean;
};

_([
  'loginForm.header.login',
  'loginForm.header.forgot',
  'loginForm.header.reset',
  'loginForm.header.update',
  'loginForm.header.create',
  'loginForm.button.login',
  'loginForm.button.forgot',
  'loginForm.button.reset',
  'loginForm.button.update',
  'loginForm.button.create',
]);

@Component({
  selector: 'ui-login-form',
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    DialogModule,
    TranslatePipe,
  ],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideComponentDefaultTranslations(translations)],
})
export class LoginFormComponent {
  // Display Elements
  logoEnabled = input<boolean>(true);
  createEnabled = input<boolean>(false);
  rememberEnabled = input<boolean>(true);
  forgotEnabled = input<boolean>(true);
  dialogEnabled = input<boolean>(false);

  // Display Mode
  dialogVisible = model<boolean>(true);
  isBusy = input<boolean>(false);

  mode = model<'login' | 'forgot' | 'reset' | 'update' | 'create'>('login');

  // Data
  username = model<string | undefined>();
  password = model<string | undefined>();
  email = model<string | undefined>();
  remember = model<boolean>(true);

  passwordNew = model<string | undefined>();
  passwordConfirm = model<string | undefined>();

  // Outputs
  createAccount = output<void>();
  forgotPassword = output<string>();

  resetPassword = output<string>();
  signIn = output<Credentials>();

  passwordsMatch = computed(() => {
    const pwNew = this.passwordNew();
    const pwTst = this.passwordConfirm();
    return (
      typeof pwNew === 'string' &&
      pwNew.length &&
      typeof pwTst === 'string' &&
      pwTst.length &&
      pwNew === pwTst
    );
  });

  sendClicked() {
    switch (this.mode()) {
      case 'login':
    }
    if (this.mode() === 'login') {
      const username = this.username();
      const password = this.password();
      const remember = this.rememberEnabled() ? this.remember() : undefined;

      if (username && password) {
        this.signIn.emit({ username, password, remember });
      }
    } else if (this.mode() === 'forgot') {
      this.forgotPassword.emit(this.email() || '');
    } else if (this.mode() === 'reset') {
      if (this.passwordsMatch()) {
        this.resetPassword.emit(this.passwordNew() as string);
      }
    }
  }
}
